import React, { Component, Fragment } from 'react';
import { withAITracking, ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { ai } from './TelemetryService';
import { withRouter } from 'react-router-dom';
import { RouteComponentProps } from 'react-router';

class TelemetryProvider extends Component<RouteComponentProps> {
    state = {
        initialized: false
    };

    componentDidMount() {
        const { history } = this.props;
        const { initialized } = this.state;
        const AppInsightsInstrumentationKey = process.env.REACT_APP_AI_KEY;
        if (!Boolean(initialized) && Boolean(AppInsightsInstrumentationKey) && Boolean(history)) {
            ai.initialize(AppInsightsInstrumentationKey as string, history);
            this.setState({ initialized: true });
        }
    }

    render() {
        const { children } = this.props;
        return (
            <Fragment>
                {children}
            </Fragment>
        );
    }
}

export default withRouter(withAITracking(ai.reactPlugin as unknown as ReactPlugin, TelemetryProvider));